import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import React from 'react';
import Amenity from '../Amenity';
import Styles from './styles'

const AmenitiesWellington = props => {
  const data = props;
  return (
    <>
      {data.title ? (
        <HeadingSection title={data.title} bgcolor="white" />
      ) : (
        <HeadingSection title="AMENITIES" bgcolor="white" />
      )}
      <div className="lg:container px-6 lg:px-0 mx-auto mb-4 pb-3 ">
        <div>
          <div className="flex justify-center  2xl:px-4">
            <div className="w-full xl:px-0 2xl:px-1">
              <div className="grid md:grid-cols-2 grid-cols-1 2xl:px-3 md:px-1 lg:px-0 justify-center gap-1 w-full">
                <div className=" ">
                  <Amenity title={data.title1} img="aminitiesCard" bgImg={data.bg1} />
                </div>
                <div className="">
                  <Amenity title={data.title2} img="aminitiesCard" bgImg={data.bg2} />
                </div>
                <div className="">
                  <Amenity title={data.title3} img="aminitiesCard" bgImg={data.bg3} />
                </div>
                <div className="">
                  <Amenity title={data.title4} img="aminitiesCard" bgImg={data.bg4} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default AmenitiesWellington;
